export const Divisions = {
  Freight: {
    name: 'Freight',
    code: 3,
  },
  Sameday: {
    name: 'Sameday',
    code: 4,
  },
  Truckmate: {
    name: 'Truckmate',
    code: 13,
  },
  SCTN: {
    name: 'SCTN',
    code: null,
  },
  SelectaService: {
    name: 'Select a Service',
    code: null,
  },
};

export const UserProfile = {
  PROFILE_INFORMATION: 'Profile Information',
  ACCOUNT_PRIVILEAGES: 'Account Privileges',
  USER_PREFERENCES: 'Order Preferences',

};

export const ShipmentStatuses = {
  Expired: 'Expired',
  Finalized: 'Finalized',
  UnderReview: 'Under Review',
  Delivered: 'Delivered',
  NotYetPickedUp: 'Not yet picked up',
  USQuote: 'US Quote',
  OrderCanceled: 'Order canceled',
};

// To increment this list when needed:
export const ShipmentStatusCode = {
  ENTRY: 'ENTRY',
  AVAIL: 'AVAIL',
  HOLD: 'HOLD',
};

export const PickupStatuses = {
  RequestReceived: 'Pick Up request Received',
  AssignedDriver: 'Assigned To Driver',
  EnRouteToShipper: 'Enroute to Shipper',
  ArrivalToShipper: 'Arrival to Shipper',
  PickedUp: 'Picked Up',
  PickUpException: 'Pick Up Exception',
  Draft: 'Draft',
};

export const QuoteStatuses = {
  Expired: 'Expired',
  Finalized: 'Finalized',
  UnderReview: 'Under Review',
  USQuote: 'US Quote',
};

export const UnitsOfMeasure = {
  Metric: 'Metric',
  Imperial: 'Imperial',
  Inches: 'Inches',
  Feet: 'Feet',
  Centimeters: 'Centimeters',
  Meters: 'Meters',
};

export const QuoteTypes = {
  USQuote: 'US Quote',
  Domestic: 'Domestic Quote',
};

export const DeliveryTypes = {
  Commercial: 'Commercial',
  Residential: 'Residential',
};

export const BillingAccountType = {
  Protected: 'Protected Billing Account',
  Billing: 'Billing Account',
};

export const Locales = {
  English: 'en',
  French: 'fr-CA',
};

export const Languages = {
  EN: 'EN',
  FR: 'FR',
};

export const Currencies = {
  USD: 'USD',
  CAD: 'CAD',
};

export const CountryCodes = {
  US: 'US',
  CANADA: 'CA',
};

export const CountryNames = {
  CANADA: 'CANADA',
  US: 'USA',
};

export const AddressTypes = {
  SHIPPER: 'shipper',
  CONSIGNEE: 'consignee',
  SHARED: 'shared',
  OTHER: 'other',
};

export const ImportContactTypes = {
  ALL: 'All',
  SHIPPER: 'Shipper (SHP)',
  CONSIGNEE: 'Consignee (CON)',
  SHARED: 'Shared (SHR – both SHP & CON)',
  OTHER: 'Other (OTH - 3rd Party etc.)',
};

export const CompanyActions = {
  DISABLECOMPANY: 'Disable Company',
};

export const ShipmentTypes = {
  US_SHIPMENT: 'USShipment',
};

export const PaymentMethods = {
  Shipper: 'Shipper',
  Receiver: 'Receiver',
  Other: 'Other',
  CreditCard: 'CreditCard',
  Prepaid: 'Prepaid',
  Collect: 'Collect',
  ThirdParty: 'Third Party',
};

export const PaymentMethodsShipment = {
  Shipper: 'Shipper',
  Receiver: 'Receiver',
  Other: 'Other',
  CreditCard: 'CreditCard',
};

export const AMPM = {
  AM: 'AM',
  PM: 'PM',
};

export const SamedayServiceType = {
  Commercial: 'C',
  Residential: 'H',
};

export const CommerceServiceType = {
  Commercial: 'C',
  Residential: 'R',
};

export const DeliveryDateTypes = {
  Unknown: 'Unknown',
  RequestedPickup: 'RequestedPickup',
  AppointmentPickup: 'AppointmentPickup',
  ActualPickup: 'ActualPickup',
  EstimatedDelivery: 'EstimatedDelivery',
  AppointmentDelivery: 'AppointmentDelivery',
  ActualDelivery: 'ActualDelivery',
};

export const PackagingGroups = {
  I: {
    name: 'I',
    value: 'I',
  },
  II: {
    name: 'II',
    value: 'II',
  },
  III: {
    name: 'III',
    value: 'III',
  },
  NotApplicable: {
    name: 'N/A',
    value: 'N/A',
  },
};

export const PackagingTypes = {
  Bag: { value: 'Bag', labelKey: 'PackagingTypeBag' },
  Box: { value: 'Box', labelKey: 'PackagingTypeBox' },
  Can: { value: 'Can', labelKey: 'PackagingTypeCan' },
  Cylinder: { value: 'Cylinder', labelKey: 'PackagingTypeCylinder' },
  Drum: { value: 'Drum', labelKey: 'PackagingTypeDrum' },
  IntermediateBulkContainer: { value: 'Intermediate Bulk Container', labelKey: 'PackagingTypeIntermediateBulkContainer' },
  Jerrican: { value: 'Jerrican', labelKey: 'PackagingTypeJerrican' },
  Pail: { value: 'Pail', labelKey: 'PackagingTypePail' },
  Tank: { value: 'Tank', labelKey: 'PackagingTypeTank' },
  Tote: { value: 'Tote', labelKey: 'PackagingTypeTote' },
  Other: { value: 'Other', labelKey: 'PackagingTypeOther' },
};

export const PrefillNumberTypes = {
  quote: 'quote',
  shipment: 'shipment',
  none: 'none',
};

export const PrefillClaimTypes = {
  damage: 'damage',
  other: 'other',
};

export const SalesforceChatLanguages = {
  English: 'en-US',
  French: 'fr',
};

export const BillToMethods = {
  enterBillTo: 'EnterBillTo',
  pickBillTo: 'PickBillTo',
};

export const SamedayShipmentType = {
  Regular: 'Regular',
  Exchange: 'Exchange',
  Return: 'Return',
};

export const shipmentPickupServiceTypes = {
  Freight: [
    'ShipInCanada',
    'ShipCanadaToUS',
    'ShipUSToCanada',
    'RequestPickup',
  ],
  Sameday: [
    'ShipInCanada',
    'RequestPickup',
  ],
  Truckmate: [
    'ShipInCanada',
    'ShipCanadaToUS',
    'ShipUSToCanada',
    'RequestPickup',
  ],
};

export const IsYesOrNo = {
  Yes: 'Yes',
  No: 'No',
};

export const LanguagesPreference = {
  English: 'English',
  French: 'French',
};

export const UnitType = {
  Imperial: 'BtnImperial',
  Metric: 'BtnMetric',
};

export const WeightLimits = {
  imperial: { global: 200, each: 75 },
  metric: { global: 91, each: 34 },
};

export const LengthLimits = {
  imperial: { each: 96 },
  metric: { each: 243 },
};

export const maxWeightImperial = {
  nonUS: 40000,
  US: 19999,
};

export const maxWeightMetric = {
  nonUS: 18143,
  US: 9071,
};

export const PrintingLabels = {
  SM: '4x6',
  LG: '10.75x7',
};

export const baseServiceLevelCode = {
  residencial1: 'R1T',
  residencial2: 'R2T',
  domesticLTL: 'LTL',
  transborderLTL: 'CBLTL',
  residencial3: 'R1NS',
};
